module.exports = __webpack_public_path__ + "static/other/gameSeekAndFind.f95bef7b.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameSeekAndFind.json
// module id = 2588
// module chunks = 0